(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/product-start-page/assets/javascripts/special-offer/views/lordagsgodis.js') >= 0) return;  svs.modules.push('/components/app/product-start-page/assets/javascripts/special-offer/views/lordagsgodis.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.app.productStartPage.specialOffer.views.Lordagsgodis = Backbone.Marionette.View.extend({
    className: '',
    template: function(data) {
      return svs.app.product_start_page.templates.lordagsgodis(data);
    },
    ui: {
      payButton: '.js-lordagsgodis-pay'
    },
    events: {
      'click @ui.payButton': 'payClick'
    },
    initialize: function() {
      this.model = new Backbone.Model({
        isOpen:
            svs.app &&
              svs.app.bags &&
              svs.app.bags.data &&
              svs.app.bags.data.lordagsgodis ?
              svs.app.bags.data.lordagsgodis.isOpen :
              false,
        disableBtn: Boolean(this.isOpen),
        btnSize: svs.core.detect.formfactor.mobile() ? '100' : '300'
      });
    },
    payClick: function(e) {
      var size = $(e.target).data('size');
      new svs.app.Bags({ bagType: 'lordagsgodis', size: size }).show();
    }
  });
})(Backbone, _, svs);

 })(window);